/*
 *  GENERAL APP LINKS
 */

export const APP_DRAWER_TOP = [
  {
    to: { name: "Home" },
    title: "commons.drawer.home",
    icon: "mdi-home"
  },
  {
    to: { name: "Projects" },
    title: "commons.drawer.projects",
    icon: "mdi-folder-open"
  },
  // {
  //   to: { name: "Audits" },
  //   title: "commons.drawer.audit",
  //   icon: "mdi-camera-control"
  // },
  {
    to: { name: "TemplateList" },
    title: "commons.drawer.forms_editing",
    icon: "mdi-calendar-text"
  },
  {
    to: { name: "DashboardReports" },
    title: "commons.drawer.statistics",
    icon: "mdi-chart-bar"
  },
  {
    icon: "mdi-chart-gantt",
    to: { name: "GanttAdmin" },
    title: "commons.drawer.gantt"
  }
]

export const APP_DRAWER_BOTTOM = [
  {
    to: { name: "Administration" },
    title: "commons.drawer.administration",
    icon: "mdi-account-cog-outline",
    // isAllowed: $ => $.$store.getters["app/isCompanyOwner"]
    isAllowed: $ => $.$store.getters["app/isUserStaff"]
  },
  {
    to: { name: "Admin" },
    title: "commons.drawer.admin",
    icon: "mdi-security",
    isAllowed: $ => $.$store.getters["app/isUserStaff"]
  },
  {
    disabled: true,
    to: { name: "Help" },
    title: "commons.drawer.help",
    icon: "mdi-help"
  }
]

/*
 *  USER ADMINISTRATION LINKS
 */
export const ADMINISTRATION_DRAWER_TOP = [
  {
    to: { name: "AdministrationUsers" },
    title: "commons.drawer.users",
    icon: "mdi-account-group"
  },
  {
    to: { name: "AdministrationUsersPending" },
    title: "commons.drawer.userPending",
    icon: "mdi-email-alert-outline"
  },
  {
    to: "#",
    title: "commons.drawer.facturation",
    icon: "mdi-credit-card-check-outline"
  }
]

/*
 *  ADMIN LINKS
 */

export const ADMIN_DRAWER_TOP = [
  {
    to: { name: "AdminSummary" },
    title: "commons.drawer.summary",
    icon: "mdi-home-analytics"
  },
  {
    to: { name: "CompaniesPlans" },
    title: "commons.drawer.companies_plans",
    icon: "mdi-domain"
  },
  {
    to: { name: "Analytics" },
    title: "commons.drawer.analytics",
    icon: "mdi-chart-line"
  },
  {
    to: { name: "AdminValidation" },
    title: "commons.drawer.validation",
    icon: "mdi-account-plus"
  },
  {
    to: { name: "AdminTemplates" },
    title: "commons.drawer.template",
    icon: "mdi-file-document-multiple"
  },
  {
    to: { name: "AdminActions" },
    title: "commons.drawer.privilege",
    icon: "mdi-gesture-double-tap"
  },
  {
    to: { name: "AdminAPIUsers" },
    title: "commons.drawer.apiUsers",
    icon: "mdi-account-group"
  }
]

/*
 *  PROJECT LINKS WITHOUT PCQ
 */

export const PROJECT_DRAWER_TOP = [
  {
    icon: "mdi-home",
    to: { name: "Project" },
    title: "commons.drawer.general",
    tooltip: "commons.drawer.general"
  },
  {
    icon: "mdi-magnify-scan",
    to: { name: "Inspections" },
    title: "commons.drawer.inspections",
    tooltip: "nav.title.Inspections_list"
  },
  {
    icon: "mdi-clipboard-alert-outline",
    to: { name: "NonConformities" },
    title: "commons.drawer.nonconformities",
    tooltip: "nav.title.nc_list"
  },
  {
    icon: "mdi-format-list-bulleted",
    to: { name: "Actions" },
    title: "nav.title.Actions",
    tooltip: "nav.title.Actions"
  },
  {
    icon: "mdi-file-document-multiple-outline",
    to: { name: "Documentation" },
    title: "commons.drawer.documentation",
    tooltip: "commons.drawer.documentation"
  },
  {
    icon: "mdi-chart-gantt",
    to: { name: "Gantt" },
    title: "commons.drawer.gantt",
    tooltip: "commons.drawer.gantt"
  },
  {
    to: { name: "InternalNotification" },
    title: "commons.drawer.notification",
    icon: "mdi-email-alert-outline",
    tooltip: "commons.drawer.notification"
  }
]

/*
 *  PROJECT LINKS WITH PCQ
 */
export const PROJECT_DRAWER_TOP_PCQ = [
  {
    icon: "mdi-home",
    to: { name: "Project" },
    title: "commons.drawer.general",
    tooltip: "commons.drawer.general"
  },
  {
    icon: "mdi-magnify-scan",
    to: { name: "Inspections" },
    title: "commons.drawer.inspections",
    tooltip: "nav.title.Inspections_list"
  },
  {
    icon: "mdi-clipboard-alert-outline",
    to: { name: "NonConformities" },
    title: "commons.drawer.nonconformities",
    tooltip: "nav.title.nc_list"
  },
  {
    icon: "mdi-format-list-bulleted",
    to: { name: "Actions" },
    title: "nav.title.Actions",
    tooltip: "nav.title.Actions"
  },
  {
    icon: "mdi-file-document-multiple-outline",
    to: { name: "Documentation" },
    title: "commons.drawer.documentation",
    tooltip: "commons.drawer.documentation"
  },
  {
    icon: "mdi-chart-gantt",
    to: { name: "Gantt" },
    title: "commons.drawer.gantt",
    tooltip: "commons.drawer.gantt"
  },
  {
    icon: "mdi-account-file",
    to: { name: "PcqLiner" },
    title: "commons.drawer.pcq_dsi",
    tooltip: "commons.drawer.pcq_dsi"
  },
  {
    to: { name: "InternalNotification" },
    title: "commons.drawer.notification",
    icon: "mdi-email-alert-outline",
    tooltip: "commons.drawer.notification"
  }
]

export const PROJECT_DRAWER_BOTTOM = [
  {
    icon: "mdi-bell-ring-outline",
    to: { name: "Cfsis" },
    title: "commons.drawer.cfsi"
  },
  {
    icon: "mdi-calendar-month",
    to: { name: "ProjectFeed" },
    title: "commons.drawer.timeline"
  },
  {
    icon: "mdi-account-group-outline",
    to: { name: "ProjectTeam" },
    title: "commons.drawer.team"
  }
]

/*
 *  TEMPLATE LINKS
 */
export const TEMPLATE_DRAWER_TOP = [
  {
    icon: "mdi-bookmark-multiple",
    to: { name: "TemplateList" },
    title: "commons.drawer.customize_templates"
  },
  {
    icon: "mdi-playlist-plus",
    to: { name: "FieldTypeEditor" },
    title: "commons.drawer.customize_fieldtypes"
  }
]

/*
 *  PROFILE LINKS
 */

export const PROFILE_DRAWER_TOP = [
  {
    to: { name: "Profile" },
    title: "commons.drawer.personal_settings",
    icon: "mdi-account-cog-outline"
  },
  {
    to: { name: "CompanyDepartment" },
    title: "commons.drawer.company_department",
    icon: "mdi-apps"
  },
  {
    to: { name: "CompanyMembers" },
    title: "commons.drawer.company_members",
    icon: "mdi-account-group"
  },
  {
    to: { name: "Logout" },
    title: "views.signup_in.signout",
    icon: "mdi-logout"
  }
]
